import React, { useState, useEffect } from "react";
import {
  MapContainer,
  TileLayer,
  useMapEvents,
  Marker,
  Popup,
  useMap,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { LineWave } from "react-loader-spinner";
import L from "leaflet";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  AddCollectionPointsDetails,
  AllCollectionPointTypeDetails,
  UpdateCollectionPointsDetails,
} from "../../Apis/collectionPointsApi";
import {
  GetZone,
  GetCirclebyID,
  GetWardsbyCircleId,
} from "../../Apis/organizationApi";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { metronome } from "ldrs";
import { useCollectionPointStore } from "./store/useCollectionPointStore";
import FilePreview from "../AssetVehicle/FilePreview";

function AddCollectionPoint({
  editCollectionDetails,
  edit,
  setLgShow,
  fetchAllCollectionPointDetails,
  setEdit,
  editPermission,
}) {
  // edit && console.log("editCollectionDetails", editCollectionDetails);
  metronome.register();
  const [position, setPosition] = useState({ lat: 17.452555, lng: 78.3599819 });
  const [zoneId, setzoneId] = useState();
  const [circleId, setcircleId] = useState();
  const [collectionPointTypes, setCollectionPointTypes] = useState([]);
  const [allZones, setAllZones] = useState([]);
  const [allCircles, setAllCircles] = useState([]);
  const [allWards, setAllWards] = useState([]);
  const [IsLoading, setISLoading] = useState(false);
  const [CollectionPointTypeName, setCollectionPointTypeName] = useState("");
  //   console.log("collectionPointTypes", collectionPointTypes);
  const getActiveZones = () =>
    allZones.filter(
      (zone) =>
        zone.isActive
    );

  const getDefaultZoneId = () => {
    if (edit && editCollectionDetails?.zoneId) {
      return editCollectionDetails.zoneId;
    }
    return getActiveZones()[0]?.zoneId ?? "";
  };

  const fetchAllDataDetails = async () => {
    try {
      const zonesData = await GetZone();
      const delhiZones = (Array.isArray(zonesData) ? zonesData : []).filter(
        (zone) =>
          zone.isActive
      );
      setAllZones(delhiZones);
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };

  //  -------------- circles-----------
  const fetchCirclesAndWards = async (zoneId) => {
    try {
      const circlesData = await GetCirclebyID(zoneId);
      setAllCircles(circlesData);
    } catch (error) { }
  };
  //  ------------ wards--------------------
  const fetchWardsData = async (circleId) => {
    try {
      const response = await GetWardsbyCircleId(circleId);
      setAllWards(response);
    } catch (error) {
      console.error("Error fetching wards data:", error);
    }
  };
  //  ----------- Route Point types------------
  const fetchCollectionPointTypes = async () => {
    try {
      const response = await AllCollectionPointTypeDetails(); // Call the API function to fetch Route Point types
      setCollectionPointTypes(response); // Update the state with the fetched Route Point types
    } catch (error) {
      console.error("Error fetching Route Point types:", error);
    }
  };

  // const {handleFileChange, filePreviews} = useCollectionPointStore();
  const [filePreviews, setFilePreviews] = useState({
    file: null,
    fileType: "",
    fileUrl: "",
  });
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Clear the previous image
      setFilePreviews({ file: null, fileType: "", fileUrl: "" });

      // Set new file after clearing the previous one
      setTimeout(() => {
        const fileUrl = URL.createObjectURL(file);
        const fileType = file.type;
        setFilePreviews({ file, fileType, fileUrl });
      }, 0);
    }
  };



  //------------------- map functionality-----

  useEffect(() => {
    fetchAllDataDetails();
    fetchCollectionPointTypes();
    if (edit && editCollectionDetails) {
      setPosition({
        lat: editCollectionDetails?.latitude,
        lng: editCollectionDetails?.longitude,
      });
      setzoneId(editCollectionDetails?.zoneId);
      setcircleId(editCollectionDetails?.circleId);
      fetchCirclesAndWards(editCollectionDetails?.zoneId);
      fetchWardsData(editCollectionDetails?.circleId);
    }
  }, [edit, editCollectionDetails]);

  useEffect(() => {
    if (edit && editCollectionDetails) return;

    const activeZones = getActiveZones();
    if (activeZones.length === 0) return;

    const firstZoneId = activeZones[0].zoneId;
    setzoneId(firstZoneId);
    setcircleId("");
    setAllWards([]);
    fetchCirclesAndWards(firstZoneId);
  }, [allZones, edit, editCollectionDetails]);

  useEffect(() => {
    if (zoneId) {
      fetchCirclesAndWards(zoneId);
    }
  }, [zoneId]);

  useEffect(() => {
    if (circleId) {
      fetchWardsData(circleId);
    }
  }, [circleId]);

  const customIcon = new L.Icon({
    iconUrl: "https://cdn-icons-png.flaticon.com/512/1483/1483336.png",
    iconSize: [48, 48],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });

  const MapEvents = ({ setFieldValue }) => {
    const map = useMap();

    useMapEvents({
      click(e) {
        if (e.latlng) {
          const { lat, lng } = e.latlng;
          setPosition({ lat, lng });
          // Update formik values for Latitude and Longitude
          setFieldValue("Latitude", lat);
          setFieldValue("Longitude", lng);
        }
      },
    });

    return null;
  };

  const submitCollectionPoint = async (formData) => {
    try {
      setISLoading(true);
      const response = edit
        ? await UpdateCollectionPointsDetails(formData)
        : await AddCollectionPointsDetails(formData);
      console.log("update", response);
      response && setISLoading(false);
      response.status === 200 && setLgShow(false);
      response.status === 200 && fetchAllCollectionPointDetails();
      response.status === 200 && setEdit(false);
      response.status === 200 &&
        toast.success(response.data, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });
    } catch (error) {
      setISLoading(false)
      console.error("Error adding Independent Engineer:", error.response?.data || error.message);

      if (error.response?.status === 400) {
        const validationErrors = error.response.data.errors || error.response.data;

        if (typeof validationErrors === "object") {
          let errorMessages = [];

          Object.keys(validationErrors).forEach((key) => {
            if (Array.isArray(validationErrors[key])) {
              validationErrors[key].forEach((msg) => {
                errorMessages.push(msg);
              });
            } else {
              errorMessages.push(validationErrors[key]);
            }
          });

          errorMessages.forEach((msg) => toast.error(msg));
          return { success: false, errors: validationErrors };
        }
      }

      // Handle general errors
      const errorMessage = error.response?.data || "Failed to add Independent Engineer";
      toast.error(errorMessage);


      return { success: false, errors: { general: errorMessage } };
    }
  };
  const handleZoneChange = (e, setFieldValue, setTouched) => {
    const newZoneId = e.target.value;
    setzoneId(newZoneId);
    setFieldValue("ZoneId", newZoneId);

    // Reset circles and wards when the zone changes
    setcircleId("");
    setAllCircles([]);
    setAllWards([]);
    setFieldValue("CircleId", "");
    setFieldValue("WardId", "");
  };
  const handleCircleChange = (e, setFieldValue, setTouched) => {
    const newCircleId = e.target.value;
    setcircleId(newCircleId);
    setFieldValue("CircleId", newCircleId);

    // Reset wards when the circle changes
    setAllWards([]);
    setFieldValue("WardId", "");
  };
  const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png"];
  const validationSchema = Yup.object({
    CollectionPointTypeId: Yup.string().required(
      "Route Point Type is Required"
    ),
    CollectionPointName: Yup.string()
      .max(250, "Must be 250 characters or less")
      .required("Route Point Name is Required"),
    CollectionPointCode: Yup.string()
      .matches(/^[A-Za-z0-9]+$/, "Only alphabets and numbers are allowed") // Allows letters and numbers
      .max(20, "Must be 20 characters or less")
      .required("Route Point Code Required"),
    ZoneId: Yup.string().required("Zone is Required"),
    CircleId: Yup.string().required("Ward is Required"),
    ImageUrl: Yup.mixed()
    .nullable(),
    // .test("fileRequired", "Route Point Image is Required", function (value) {
    //   return !!value;
    // })
    // .test(
    //   "fileType",
    //   "Only image file formats are supported.",
    //   function (value) {
    //     if (!value) return true;

    //     // If it's a File object
    //     if (value instanceof File) {
    //       return SUPPORTED_FORMATS.includes(value.type);
    //     }

    //     // If it's a string (URL), check extension
    //     if (typeof value === "string") {
    //       return /\.(jpe?g|png)$/i.test(value);
    //     }

    //     return false;
    //   }
    // ),
    Latitude: Yup.number().required("Latitude is required").test(
      "is-decimal",
      "Latitude must be a decimal number",
      (value) => value !== undefined && value.toString().includes(".")
    ),
    Longitude: Yup.number()
      .required("Longitude is required")
      .test(
        "is-decimal",
        "Longitude must be a decimal number",
        (value) => value !== undefined && value.toString().includes(".")
    ),
    // IsActive: Yup.boolean().required("Required"), // For the checkbox
    // Custom validation for Shifts
    ShiftA: Yup.boolean(),
    ShiftB: Yup.boolean(),
    ShiftC: Yup.boolean(),
    // atLeastOneShift: Yup.mixed().test(
    //   "at-least-one-shift",
    //   "At least one shift must be selected",
    //   function (value) {
    //     const { ShiftA, ShiftB, ShiftC } = this.parent;
    //     return ShiftA || ShiftB || ShiftC;
    //   }
    // ),
  });

  const initialValues = {
    CollectionPointId: edit ? editCollectionDetails?.collectionPointId : "",
    CollectionPointTypeId: edit
      ? editCollectionDetails?.collectionPointTypeId
      : null,
    CollectionPointTypeName: "",
    CollectionPointName: edit ? editCollectionDetails?.collectionPointName : "",
    CollectionPointCode: edit ? editCollectionDetails?.collectionPointCode : "",
    ZoneId: getDefaultZoneId(),
    CircleId: edit ? editCollectionDetails?.circleId : "",
    // WardId: edit ? editCollectionDetails?.wardId : "",
    Latitude: (edit ? editCollectionDetails?.latitude : null) || position.lat,
    Longitude: (edit ? editCollectionDetails?.longitude : null) || position.lng,
    Remarks: edit ? editCollectionDetails?.remarks : "",
    ImageUrl: edit ? editCollectionDetails?.imageUrl : null,
    IsActive: edit ? editCollectionDetails?.isActive : true,
    ShiftA: edit ? editCollectionDetails?.shiftA : false,
    ShiftB: edit ? editCollectionDetails?.shiftB : false,
    ShiftC: edit ? editCollectionDetails?.shiftC : false,
  };

  const onSubmit = (values) => {

    if (!values.ShiftA && !values.ShiftB && !values.ShiftC) {
      values.IsActive = false;
    }

    values.CollectionPointTypeId = values.CollectionPointTypeId;
    values.CollectionPointCode = (values.CollectionPointCode);
    values.ZoneId = values.ZoneId;
    values.CircleId = values.CircleId;
    // values.WardId = values.WardId;
    values.Latitude = values.Latitude;
    values.Longitude = values.Longitude;
    submitCollectionPoint(values);
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {({ values, setFieldValue, errors, touched, setFieldTouched, setErrors }) => (
          <Form>
            {/* ... (previous code) */}
            <div className="row">
              {/*Route Point Type  */}
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Route Point Type{" "}
                    <span style={{ color: "#EC1117" }}> *</span>{" "}
                  </label>
                  <Field
                    as="select"
                    className="form-select"
                    name="CollectionPointTypeId"
                    onChange={(e) => {
                      const selectedCollectionType = collectionPointTypes.find(
                        (collectionPointType) =>
                          collectionPointType.collectionPointTypeId === parseInt(e.target.value)
                      );

                      if (selectedCollectionType) {
                        setFieldValue("CollectionPointTypeId", selectedCollectionType.collectionPointTypeId);
                        setFieldValue("CollectionPointTypeName", selectedCollectionType.collectionPointTypeName);
                      }
                      else {
                        setFieldValue("CollectionPointTypeId", "");
                        setFieldValue("CollectionPointTypeName", "");
                      }

                      // Clear validation error when a value is selected
                      setFieldTouched("CollectionPointTypeId", false);
                    }}
                  >

                    <option value="">Select</option>
                    {collectionPointTypes.map((collectionPoint) => (
                      <option
                        value={collectionPoint.collectionPointTypeId}
                        key={collectionPoint.collectionPointTypeId}
                      >
                        {collectionPoint.collectionPointTypeName}
                      </option>

                    ))}
                    {/* <option value="">Select</option> */}
                    {/* <option value="1">GVP</option>
                    <option value="4">Sweeping Points</option> */}
                  </Field>
                  <ErrorMessage
                    name="CollectionPointTypeId"
                    component="div"
                    className="text-danger"
                  />
                </div>
              </div>
              {/*Route Point Name  */}
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Route Point Name
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    type="text"
                    name="CollectionPointName"
                    placeholder="Enter Point Name"
                    className={`form-control`}
                    maxLength={42}
                  />
                  <ErrorMessage
                    name="CollectionPointName"
                    component="div"
                    className="text-danger"
                  />
                </div>
              </div>
              {/*Route Point Code  */}
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Route Point Code{" "}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    type="text"
                    name="CollectionPointCode"
                    placeholder="Enter Route Point Code"
                    className={`form-control `}
                    maxLength={8}
                  // for not accepting negitive values

                  />
                  <ErrorMessage
                    name="CollectionPointCode"
                    component="div"
                    className="text-danger"
                  />
                </div>
              </div>
              {/* Zone */}
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Zone <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    as="select"
                    className="form-select"
                    name="ZoneId"
                    onChange={(e) => {
                      handleZoneChange(e, setFieldValue, setFieldTouched, setErrors);
                      setFieldTouched("ZoneId", false); // Ensure validation clears
                    }}

                  >
                    {allZones
                      .filter((zone) => zone.isActive)
                      .map((zone) => (
                        <option value={zone.zoneId} key={zone.zoneId}>
                          {zone.zoneName}
                        </option>
                      ))}
                  </Field>
                  <ErrorMessage
                    name="ZoneId"
                    component="div"
                    className="text-danger"
                  />
                </div>
              </div>

              {/* Circle */}
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Ward <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    as="select"
                    className="form-select"
                    name="CircleId"
                    disabled={!values.ZoneId}
                    onChange={(e) => {
                      handleCircleChange(e, setFieldValue, setFieldTouched)
                      setFieldTouched("CircleId", false)
                    }}
                  >
                    <option value="">Select</option>
                    {allCircles.filter((circle) => circle.isActive)
                      .map((circle) => (
                        <option value={circle.circleId} key={circle.circleId}>
                          {circle.circleName}
                        </option>
                      ))}
                  </Field>
                  <ErrorMessage
                    name="CircleId"
                    component="div"
                    className="text-danger"
                  />
                </div>
              </div>

              {/* Ward */}
              {/* <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">Ward</label>
                  <Field
                    as="select"
                    className="form-select"
                    name="WardId"
                    disabled={!values.CircleId}
                    onChange={(e) => {
                      setFieldValue("WardId", e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {allWards.filter((ward) => ward.isActive)
                      .map((ward) => (
                        <option value={ward.wardId} key={ward.wardId}>
                          {ward.wardName}
                        </option>
                      ))}
                  </Field>
                </div>
              </div> */}

              {/* image */}
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Route Point Image
                    {/* {editCollectionDetails?"":<span style={{ color: "#EC1117" }}> *</span>} */}
                  </label>

                  <input
                    type="file"
                    name="ImageUrl"
                    className="form-control"
                    accept=".png, .jpg, .jpeg"
                    // onChange={(event) => {
                    //   setFieldValue("ImageUrl", event.currentTarget.files[0]);
                    // }}
                    onChange={(e) => {
                      handleFileChange(e, "ImageUrl");
                      setFieldValue("ImageUrl", e.currentTarget.files[0]);
                    }}
                  />

                  <ErrorMessage
                    name="ImageUrl"
                    component="div"
                    className="text-danger"
                  />
                  {values.ImageUrl && edit &&
                    editCollectionDetails?.imageUrl && (
                      <div>
                        <img
                          src={editCollectionDetails.imageUrl}
                          alt="Route Point"
                          width="100"
                        />
                        {/* <p className="fw-bold">
                          Current image. Upload a new image to Update it.
                        </p> */}
                      </div>
                    )}
                  {(filePreviews?.fileUrl && filePreviews?.fileType !== "application/pdf" ) && (
                    <FilePreview
                      file={filePreviews.file}
                      fileType={filePreviews.fileType}
                      fileUrl={filePreviews.fileUrl}
                      width="100"
                    />
                  )}
                </div>


              </div>

              {/* Latitude */}
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Latitude <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    type="number"
                    name="Latitude"
                    className="form-control"
                  // value={position.lat || ""}
                  // onChange={(e) => setFieldValue("Latitude", e.target.value)}
                  />
                  <ErrorMessage
                    name="Latitude"
                    component="div"
                    className="text-danger"
                  />
                </div>
              </div>
              {/* Longitude */}
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Longitude <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    type="number"
                    name="Longitude"
                    className="form-control"
                  // value={position.lng || ""}
                  // onChange={(e) => setFieldValue("Longitude", e.target.value)}
                  />
                  <ErrorMessage
                    name="Longitude"
                    component="div"
                    className="text-danger"
                  />
                </div>
              </div>
              {/* Remarks */}
              <div className="col-md-12 mb-3">
                <div
                  className="form-group"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <label className="form-label">Remarks</label>
                  <Field
                    as="textarea"
                    name="Remarks"
                    rows={2}
                    maxLength={500} />
                </div>
              </div>
            </div>
            {/* radio buttons */}
            <div className="form-group" style={{ display: "flex" }}>
              <div className="form-check">
                <Field
                  type="radio"
                  name="IsActive"
                  value={true}
                  className="form-check-input"
                  checked={values.IsActive === true}
                  onChange={() => setFieldValue("IsActive", true)}
                />
                <label className="form-check-label">Active</label>
              </div>
              <div className="form-check" style={{ marginLeft: "40px" }}>
                <Field
                  type="radio"
                  name="IsActive"
                  value={false}
                  className="form-check-input"
                  checked={values.IsActive === false}
                  onChange={() => setFieldValue("IsActive", false)}
                />
                <label className="form-check-label">Inactive</label>
              </div>
            </div>

            {/* check boxes */}
            <div className="col-md-6" style={{ marginTop: "5px" }}>
              <label className="form-label">
                Shift
                {/* <span style={{ color: "#EC1117" }}> *</span> */}
              </label>
              <div className="form-group" style={{ display: "flex" }}>
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="ShiftA"
                    className="form-check-input"
                  />

                  <label className="form-check-label" htmlFor="activeRadio">
                    A
                  </label>
                </div>
                {/* shift B */}
                <div className="form-check" style={{ marginLeft: "40px" }}>
                  <Field
                    type="checkbox"
                    name="ShiftB"
                    className="form-check-input"
                    id="afternoon"
                  />

                  <label className="form-check-label" htmlFor="inactiveRadio">
                    B
                  </label>
                </div>
                {/* shift C */}
                <div className="form-check" style={{ marginLeft: "40px" }}>
                  <Field
                    type="checkbox"
                    name="ShiftC"
                    className="form-check-input"
                    id="evening"
                  />

                  <label className="form-check-label" htmlFor="inactiveRadio">
                    C
                  </label>
                </div>
              </div>
              {/* Displaying custom validation error */}
              {errors.atLeastOneShift && touched.ShiftA && (
                <div className="text-danger ">{errors.atLeastOneShift}</div>
              )}
            </div>

            {/*--- map-- */}
            <div className="col-md-12">
              <div className="form-group">
                <label className="form-label">Map</label>
                <div className="p-20">
                  <MapContainer
                    center={
                      edit && position.lat !== null
                        ? [position.lat, position.lng]
                        : [17.452555, 78.3599819]
                    }
                    zoom={13}
                    style={{ height: "300px", width: "100%" }}
                  >
                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    <MapEvents setFieldValue={setFieldValue} />

                    {position.lat !== null && position.lng !== null && (
                      <Marker
                        position={[position.lat, position.lng]}
                        icon={customIcon}
                      >
                        <Popup>
                          Latitude: {position.lat}, Longitude: {position.lng}
                        </Popup>
                      </Marker>
                    )}
                  </MapContainer>
                </div>
              </div>
            </div>

            {/* submit */}
            {<div className="modal-footer d-flex justify-content-center">
              <button
                type="submit"
                className="deployment-button"
                disabled={IsLoading}
              >
                {IsLoading ? (
                  <l-metronome size="40" speed="1.8" color="red" />
                ) : (
                  <div>
                    <i className="fa-solid fa-check done-container"></i>
                    {edit ? "Update" : "Save"}
                  </div>
                )}
              </button>
            </div>}
          </Form>
        )}
      </Formik>
      {/* <ToastContainer /> */}
    </div>
  );
}

export default AddCollectionPoint;
